import React from 'react';
import './unauth-layout.styles.scss';
import UnauthHeader from './unauth-head.component';
import Footer from './footer/footer.component';
import { Desktop, LargeTablet, Mobile, Tablet } from '@/utils/responsiveQueries';
import UnauthHeaderMobile from './unauth-header-mobile.component';

const UnauthLayout = ({ children }) => {
    return (
        <div className='unauth-layout'>
            <Desktop>
                <UnauthHeader />
                <div className='layout-body'>
                    {children}
                    
                </div>
            </Desktop>
            
            <LargeTablet>
                <div className='header-container'>
                    <UnauthHeader />
                </div>
                <div className='layout-body'>
                    {children}
                    
                </div>
            </LargeTablet>

            <Tablet>
                <UnauthHeaderMobile />
                <div className='mobile-content-container'>
                    {children}
                </div>
            </Tablet>

            <Mobile>
                <UnauthHeaderMobile />
                <div className='mobile-content-container'>
                    {children}
                </div>
            </Mobile>
        </div>
    )
}

export default UnauthLayout